import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { typography, fontWeights } from '../../../styles/typography';
import { MediaQueries } from '../../../styles/Grid';
import { Edges, VIEWPORTS } from '../../../styles/Grid/GridSizes';

export const container = css({
  position: 'relative',
  backgroundColor: colorsPalette.brown10,
  [MediaQueries.lgAndUp]: {
    paddingBottom: 65,
    minHeight: 730,
  },
});

export const overflowContainer = css({
  [MediaQueries.lgAndUp]: {
    overflowX: 'hidden',
  },
});

export const content = css({
  padding: '30px 0 40px',
  [MediaQueries.mdAndUp]: {
    padding: '43px 0 75px',
  },
  [MediaQueries.lgAndUp]: {
    padding: '112px 0 95px',
    minHeight: 540,
  },
  [MediaQueries.xl]: {
    minHeight: 655,
  },
});

export const title = css(typography.effra48, {
  fontWeight: fontWeights.medium,
  lineHeight: 1.2,
  position: 'relative',
  marginTop: 0,
  marginBottom: 18,
});

export const locationsIndicator = css(typography.effra12, {
  display: 'inline-block',
  backgroundColor: colorsPalette.teal,
  color: colorsPalette.white,
  fontWeight: fontWeights.medium,
  borderRadius: 2,
  padding: '4px 8px',
  marginRight: 9,
});

export const locationsCtaAnchor = css({
  '&:visited': {
    textDecoration: 'none',
  },
  '&:link': {
    textDecoration: 'none',
  },
  '&:hover': {
    '.locations-cta-text': {
      borderBottom: `1px solid ${colorsPalette.grey80}`,
    },
  },
});

export const locationsCtaLink = css({
  textDecoration: 'none',
  paddingBottom: 2,
  borderBottom: `1px solid ${colorsPalette.grey40}`,
});

export const locationsSubtitle = css({
  marginBottom: 18,
  [MediaQueries.mdAndUp]: {
    marginBottom: 33,
  },
});

export const subtitle = css(typography.effra12, {
  textTransform: 'uppercase',
  letterSpacing: 0.8,
  fontWeight: fontWeights.medium,
  color: colorsPalette.grey,

  'html[lang="hu"] &': {
    fontSize: '11px',
  },
});

export const secondSubtitle = css({
  marginTop: 20,
  display: 'block',
  [MediaQueries.mdAndUp]: {
    display: 'inline',
  },
});

export const separator = css({
  color: colorsPalette.brown40,
  margin: '0 6px',
});

export const locationSeparator = css({
  display: 'none',
  [MediaQueries.mdAndUp]: {
    display: 'inline-block',
  },
});

export const description = css(typography.effra18, {
  lineHeight: 1.66,
  color: colorsPalette.grey80,
  marginTop: 15,
  [MediaQueries.lgAndUp]: {
    marginTop: 30,
  },
});

export const phoneNumber = css(typography.effra16, {
  color: colorsPalette.black,
  display: 'inline-block',
  marginTop: 21,
  [MediaQueries.md]: {
    marginTop: 32,
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 40,
  },
  '.phone-container': {
    alignItems: 'center',
  },
});

export const formContainer = css({
  display: 'none',
  [MediaQueries.lgAndUp]: {
    maxWidth: 'none',
    marginTop: 32,
    display: 'block',
  },
});

export const primaryButton = css({
  marginBottom: 24,
});

export const mainImage = css({
  display: 'block',
  img: {
    width: '100%',
    height: 'auto',
    [MediaQueries.lgAndUp]: {
      width: 907,
      height: 679,
    },
  },
  [MediaQueries.mdAndUp]: {
    paddingLeft: Edges[VIEWPORTS.md],
  },
  [MediaQueries.lgAndUp]: {
    paddingLeft: 0,
    marginTop: 112,
    maxWidth: 520,
  },
  [MediaQueries.xl]: {
    maxWidth: 670,
  },
});

export const imageContainerBleed = css({
  [MediaQueries.lgAndUp]: {
    display: 'flex',
    flexDirection: 'row-reverse',
  },
});

export const leftImage = css({
  display: 'none',
  img: {
    width: '100%',
    height: 'auto',
  },
  [MediaQueries.lgAndUp]: {
    display: 'block',
    position: 'absolute',
    top: 242,
    left: -440,
    maxHeight: 312,
    maxWidth: 500,
  },
});

export const dropdownsContainer = css({
  display: 'flex',
  marginBottom: 20,
});

export const dropdown = css({
  flex: 1,
  '&:first-of-type': {
    marginRight: 10,
  },
});

export const dropdownLabel = css({
  borderColor: colorsPalette.white,
});
